export default __webpack_public_path__ + "static/media/telegram.6640f84c.svg";